import { DateUtils } from "../Utils/DateUtils";

export class OWTime extends Date {
    constructor();
    constructor(value: number | string | Date);
    constructor(hours?: any, minutes?: number, seconds?: number, ms?: number) {
        if (minutes || minutes === 0)
            super(1970, 0, 1, hours, minutes, seconds, ms);
        else {
            if (hours instanceof Date)
                super(hours.getTime());
            else if (typeof hours === "string") {
                const parsedVal = DateUtils.fromXsdDateTime(hours[10] === "T" ? hours : "1970-01-01T" + hours);
                super(parsedVal ? parsedVal.getTime() : Number.NaN); // pokud se nepovedlo sparsovat bude vracen Invalid Date
            } else
                super(hours);

            //Chrome 42 s funkci .toLocaleString() spatne zobrazuje cas pokud datum je mensi jak 31.12.1899
            //odstranena datumova cast - takto je datum 1.1.1970
            super.setFullYear(1970, 0, 1);
        }
    }

    public override toString(): string {
        return super.toTimeString();
    }

    public override toDateString(): string {
        return "";
    }

    public override toLocaleTimeString(locale?: string | string[], options?: Intl.DateTimeFormatOptions): string {
        return super.toLocaleTimeString(locale as any, options);
    }

    public override toLocaleString(locale?: string | string[], options?: Intl.DateTimeFormatOptions): string {
        return super.toLocaleTimeString(locale as any, options);
    }

    public override toLocaleDateString(): string {
        return "";
    }

    public override toJSON(): string {
        return DateUtils.toXsdDateTime(this).substr(11);
    }
}
